import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux Form 7 tracks validator getters by name, but removes the getter whenever
// any Field with that name unmounts. Keep ownership for each container instead.
const registries = new WeakMap();

const collectValidators = (owners, key) => () => {
    const validators = owners.reduce((all, owner) => {
        const getter = owner[key];
        return getter ? all.concat(getter() || []) : all;
    }, []);
    return validators.length ? validators : undefined;
};

class ContainerFields extends Component {
    constructor(props, context) {
        super(props, context);
        this.registrations = new Map();
        this.register = this.register.bind(this);
        this.unregister = this.unregister.bind(this);
    }

    getRegistry() {
        const form = this.context._reduxForm;
        if (form.containerFieldRegistry) return form.containerFieldRegistry;
        if (!registries.has(form.register)) {
            registries.set(form.register, {
                register: form.register,
                unregister: form.unregister,
                fields: new Map()
            });
        }
        return registries.get(form.register);
    }

    register(name, type, getValidator, getWarner) {
        const registry = this.getRegistry();
        const owner = { getValidator, getWarner };
        const local = this.registrations.get(name) || [];
        local.push(owner);
        this.registrations.set(name, local);
        const owners = registry.fields.get(name);
        if (owners) {
            owners.push(owner);
            // Update Redux's reference count without replacing the shared getter.
            this.context._reduxForm.registerField(name, type);
        } else {
            const firstOwners = [owner];
            registry.fields.set(name, firstOwners);
            registry.register(name, type,
                collectValidators(firstOwners, 'getValidator'),
                collectValidators(firstOwners, 'getWarner'));
        }
    }

    unregister(name) {
        const local = this.registrations.get(name);
        if (!local || !local.length) return;
        const owner = local.pop();
        if (!local.length) this.registrations.delete(name);
        const registry = this.getRegistry();
        const owners = registry.fields.get(name);
        owners.splice(owners.indexOf(owner), 1);
        if (owners.length) {
            // Other visible containers still need this field's validation.
            this.context._reduxForm.unregisterField(name, false);
        } else {
            registry.fields.delete(name);
            registry.unregister(name);
        }
    }

    getChildContext() {
        const form = this.context._reduxForm;
        return { _reduxForm: form ? {
            ...form,
            containerFieldRegistry: this.getRegistry(),
            register: this.register,
            unregister: this.unregister
        } : form };
    }

    render() {
        return this.props.children;
    }
}

ContainerFields.contextTypes = { _reduxForm: PropTypes.object };
ContainerFields.childContextTypes = { _reduxForm: PropTypes.object };

export default ContainerFields;
